var cartmenubtn = document.querySelector('a.header__icon-wrapper.tap-area[aria-controls="mini-cart"]');
cartmenubtn.addEventListener('click',function(){
    
    setTimeout(() => {
         const slides = document.querySelectorAll(".custom-slide");
    let currentIndex = 0;
  
    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.style.opacity = i === index ? "1" : "0";
        });
    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    }

    // Initial setup
    showSlide(currentIndex);

    // Auto-slide every 3 seconds
    setInterval(nextSlide, 3000);
    }, 1000);

})



if(document.body.classList.contains('special-offers')){
   setTimeout(() => {
var popupbtncrt  = document.querySelectorAll('div#freegifts-main-popup-container .bogos-gift-item-add-btn');
popupbtncrt.forEach(function(sghide) {
    sghide.addEventListener('click',function () {
        document.querySelector('div#freegifts-main-popup-container').classList.remove('sca-is-visible-fg')
    })
})

     }, 1000);
}